'use client';

import Image from 'next/image';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { PartnerLogoData } from '@/types/PartnerLogoData';

export default function PartnerLogos({ partnerLogoData }: { partnerLogoData: PartnerLogoData[] }) {
	const theme = useTheme();
	const isMobileOrTablet = useMediaQuery(theme.breakpoints.down('md'));
	return (
		<Box
			sx={{
				display: 'flex',
				width: '100%',
				justifyContent: 'center',
				alignItems: 'center',
				gap: { xs: '10px', md: '24px' },
				flexWrap: 'wrap',
			}}
		>
			{partnerLogoData.map(
				({ src: imageSrc, name: partnerName, desktopHeight, desktopWidth, mobileHeight, mobileWidth }) => (
					<Image
						width={isMobileOrTablet ? mobileWidth : desktopWidth}
						height={isMobileOrTablet ? mobileHeight : desktopHeight}
						src={imageSrc}
						alt={`${partnerName} logo`}
						priority
						key={imageSrc}
					/>
				),
			)}
		</Box>
	);
}
